<script setup lang="ts">
import { gaiaNeutral } from '../themes/tokens';

const props = defineProps({
  /** Rail width — 288px in the mock. */
  railWidth: {
    type: String,
    default: '288px',
  },
});

const cardBorder = gaiaNeutral.borderCard;
const surface = gaiaNeutral.surface;
const railBg = gaiaNeutral.surfaceSoft;
const railBorder = gaiaNeutral.borderDivider;
const stripBorder = gaiaNeutral.borderDivider;
</script>

<template>
  <div class="gaia-run-focus">
    <aside class="rail" :style="{ width: props.railWidth }">
      <div v-if="$slots['rail-header']" class="rail-header">
        <slot name="rail-header" />
      </div>
      <div class="scroller">
        <slot name="rail" />
      </div>
      <div v-if="$slots['rail-footer']" class="rail-footer">
        <slot name="rail-footer" />
      </div>
    </aside>

    <section class="pane">
      <div v-if="$slots.header" class="pane-header">
        <slot name="header" />
      </div>
      <div class="scroller pane-body">
        <slot />
      </div>
    </section>
  </div>
</template>

<style scoped>
.gaia-run-focus {
  flex: 1;
  min-height: 0;
  display: flex;
  overflow: hidden;
  border: 1px solid v-bind(cardBorder);
  border-radius: 10px;
  background: v-bind(surface);
}

.rail {
  flex: none;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: v-bind(railBg);
  border-right: 1px solid v-bind(railBorder);
}

/* The rail's own 40px label row, matching the table header it sits beside. */
.rail-header {
  flex: none;
  display: flex;
  align-items: center;
  gap: 8px;
  height: 40px;
  padding: 0 12px 0 16px;
  border-bottom: 1px solid v-bind(stripBorder);
}

/* Pinned under the rail's scroller, e.g. a GaiaDocPager. The -1px tucks the
   pager's own bottom border under the card's, which the rail clips. */
.rail-footer {
  flex: none;
  margin-bottom: -1px;
  border-top: 1px solid v-bind(stripBorder);
}

.pane {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.pane-header {
  flex: none;
  display: flex;
  align-items: center;
  gap: 12px;
  height: 52px;
  padding: 0 20px;
  border-bottom: 1px solid v-bind(stripBorder);
}

.scroller {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}

.pane-body {
  padding: 18px 20px 20px;
}
</style>
